import { render, staticRenderFns } from "./SupporterDetails.vue?vue&type=template&id=6d55c08a&"
import script from "./SupporterDetails.vue?vue&type=script&lang=js&"
export * from "./SupporterDetails.vue?vue&type=script&lang=js&"
import style0 from "./SupporterDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d55c08a')) {
      api.createRecord('6d55c08a', component.options)
    } else {
      api.reload('6d55c08a', component.options)
    }
    module.hot.accept("./SupporterDetails.vue?vue&type=template&id=6d55c08a&", function () {
      api.rerender('6d55c08a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DonationModal/SupporterDetails.vue"
export default component.exports